import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import {Step} from '../TvResetParentalCodeBlock/ResetParentalCodeEnum';

export const validateUserBeforeResetParentalCode = createAsyncThunk('tvActivationCodeRecoveryBlock/validateUserBeforeResetParentalCode', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
        const result = await ProviderManager.getProviderData('validateUserBeforeResetParentalCode', [
            data.id,
            data.card,
            data.externalAssetId,
        ]);
        thunkAPI.dispatch(hideAppLoader());
        return result.Body;
    } catch (error) {
        console.info(error);
        return false;
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});
export const getTvCustomerList = createAsyncThunk('tvActivationCodeRecoveryBlock/getTvCustomerList', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());

    try {
        const result = await ProviderManager.getProviderData('getTvCustomerList', []);
        let res = null;

        if (result.Body.length === 1 && !data?.isParentalCode) {
            try {
                res = await thunkAPI.dispatch(getTvCode(result.Body[0].ban));
            } catch (error) {
                console.error("פרטי כניסה לאפליקציה/ממיר:", error);
            };
        };

        return { result, res };

    } catch (error) {
        console.info(error);
        return false;
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const doTvActivationCodeRecovery = createAsyncThunk('tvActivationCodeRecoveryBlock/doTvActivationCodeRecovery', async (data, thunkAPI) => {
        thunkAPI.dispatch(showAppLoader());
        try {
            const result = await ProviderManager.getProviderData('doTvActivationCodeRecovery', [data.source, data.assetExternalId, data.psid]);
            return result.Body.isSuccess;
        } catch (error) {
            console.info(error);
            return false;
        } finally {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
);

export const doResetParentalCode = createAsyncThunk('tvActivationCodeRecoveryBlock/doResetParentalCode', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
        const result = await ProviderManager.getProviderData('doResetParentalCode', [
            data.externalAssetId,
            data.pinCode,
        ]);
        thunkAPI.dispatch(hideAppLoader());

        return result.Body.isSuccess;
    } catch (error) {
        console.info(error);
        return false;
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const getTvCode = createAsyncThunk('tvActivationCodeRecoveryBlock/getTvCode', async (data, thunkAPI) => {
        thunkAPI.dispatch(showAppLoader());
        try {
            const result = await ProviderManager.getProviderData('getTvCode', [data]);
            return result.Body;
        } catch (error) {
            console.info(error);
            return false;
        } finally {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
);

export const tvActivationCodeRecoverySms = createAsyncThunk('tvActivationCodeRecoveryBlock/tvActivationCodeRecoverySms', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
        const result = await ProviderManager.getProviderData('tvActivationCodeRecoverySms', [data]);
        return result.Body;
    } catch (error) {
        console.info(error);
        return false;
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
}
);



export const generateUserPasswordTv = createAsyncThunk(
    ' tvActivationCodeRecoveryBlock/generateUserPasswordTv',
    async (data, thunkAPI) => {
        thunkAPI.dispatch(showAppLoader());
        const params =
        {
          ban: data.ban,
          activationCode: data.tvCode
        }
        try {
            const result = await ProviderManager.getProviderData('generateUserPasswordTv', params);
            return result.Body;
        } catch (error) {
            console.info(error);
            return false;
        } finally {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
);


export const getPinParentalCodeAsync = createAsyncThunk('tvActivationCodeRecoveryBlock/getPinParentalCodeAsync', async (data, thunkAPI) => {
        thunkAPI.dispatch(showAppLoader());

        try {
            const state = thunkAPI.getState().TvActivationCodeRecovery;
            const result = await ProviderManager.getProviderData('getPinParentalCode', [state.currentParrentalCodeAccount?.ban]);
            return result.Body;
        } catch (error) {

        } finally {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
);

const initialState = {
    blockId: 0,
    customerList: [],
    selectedCustomer: {
        psid: '',
        source: '',
        assetExternalId: '',
        ban: ''
    },
    redirectUrl: '',
    isSuccess: false,
    showLoader: false,
    showCustomerList: false,
    showRecoveryButton: false,
    showSuccessMessage: false,
    showErrorMessage: false,
    showEmptyListMessage: false,
    getCustomersReady: false,
    //resetParentalCodeIsSuccess: null,
    //resetParentalCodeReady: false,
    parentalCodeStep: Step.START,
    currentParrentalCodeAccount: null,
    validateUserAndCard: null,
    displayPopUp: false,
    infoTv:{},
    activationCode: '',
    isPasswordUpdate: false,
    pinParentalCode: '',
    tvParameters: {}
};


const tvActivationCodeRecoveryBlockSlice = createSlice({
    name: 'tvActivationCodeRecoveryBlock',
    initialState: initialState,
    reducers: {
        resetState: (state) => initialState,
        saveToHistory: (state, action) => {
            return state;
        },
        setCurrentParrentalCodeAccount: (state, action) => {
            state.currentParrentalCodeAccount = action.payload;
        },
        setParentalCodeStep: (state, action) => {
            state.parentalCodeStep = action.payload;
        },
        setValidateUserAndCard: (state, action) => {
            state.validateUserAndCard = action.payload;
        },

        setRedirectUrl: (state, action) => {
            state.redirectUrl = action.payload ?? Config.lobbyUrl;
        },
        setRequestData: (state, action) => {
            state.selectedCustomer = {
                psid: action.payload.psid,
                source: action.payload.sourceSystem,
                assetExternalId: action.payload.assetExternalId,
                ban: action.payload.ban,
            };
            state.showLoader = false;
            state.showCustomerList = false;
            state.showRecoveryButton = true;
            state.showSuccessMessage = false;
            state.showErrorMessage = false;
            state.showEmptyListMessage = false;
        },
        prepareActivationCodeRecovery: (state, action) => {
            state.showLoader = true;
            state.showCustomerList = false;
            state.showRecoveryButton = true;
            state.showSuccessMessage = false;
            state.showErrorMessage = false;
            state.showEmptyListMessage = false;
            state.isSuccess = false;
        },
        closeFlow: (state, action) => {
            state.selectedCustomer = {
                personId: '',
                source: '',
                assetExternalId: '',
                ban: ''
            };
            if (state.customerList.length > 1) {
                state.showLoader = false;
                state.showCustomerList = true;
                state.showRecoveryButton = false;
                state.showSuccessMessage = false;
                state.showErrorMessage = false;
                state.showEmptyListMessage = false;
            } else {
                window.location.href = state.redirectUrl;
            }
        },
        startCall: (state, action) => {
        },
        toggleDisplayPopUp: (state, action) => {
            state.displayPopUp = !state.displayPopUp;
        },
        setSuccessMessage :  (state, action) =>{
            state.showLoader = false;
            state.showCustomerList = false;
            state.showRecoveryButton = false;
            state.showSuccessMessage = true;
            state.showErrorMessage = false;
            state.showEmptyListMessage = false;
        },
        setPasswordUpdate:  (state, action) =>{
            state.infoTv.tvCode = state.activationCode;
        },
        setIsPasswordUpdate:  (state, action) =>{
            state.isPasswordUpdate  = action.payload;
        },
        reportDWH: (state, action) => { },
    },
    extraReducers: {
        // [doResetParentalCode.fulfilled]: (state, action) => {
        //     state.resetParentalCodeIsSuccess = action.payload;
        //     state.resetParentalCodeReady = true;
        // },
        [validateUserBeforeResetParentalCode.fulfilled]: (state, action) => {
            state.validateUserAndCard = action.payload;
        },
        [getTvCustomerList.fulfilled]: (state, action) => {
            state.validateUserAndCard = null;
            let isError = action.payload.result  == undefined || action.payload.result   == false;
            isError = isError ? isError : action.payload.result.Header.ReturnCode != 0;
            if (isError) {
                state.showLoader = false;
                state.showCustomerList = false;
                state.showRecoveryButton = false;
                state.showSuccessMessage = false;
                state.showErrorMessage = true;
                state.showEmptyListMessage = false;
            }

            state.customerList = isError ? [] : action.payload.result.Body;

            if (!isError && state.customerList.length > 1) {
                state.showLoader = false;
                state.showCustomerList = true;
                state.showRecoveryButton = false;
                state.showSuccessMessage = false;
                state.showErrorMessage = false;
                state.showEmptyListMessage = false;
            }
            if (!isError && state.customerList.length == 1) {

                state.selectedCustomer = {
                    psid: state.customerList[0].psid,
                    source: state.customerList[0].sourceSystem,
                    assetExternalId: state.customerList[0].assetExternalId,
                    ban: state.customerList[0].ban
                };

                if (action.payload.res && action.payload.res.payload) {
                    state.infoTv = action.payload.res.payload.tvParameters;
                };

                state.showLoader = false;
                state.showCustomerList = false;
                state.showRecoveryButton = true;
                state.showSuccessMessage = false;
                state.showErrorMessage = false;
                state.showEmptyListMessage = false;
            }
            if (!isError && state.customerList.length == 0) {
                state.showLoader = false;
                state.showCustomerList = false;
                state.showRecoveryButton = false;
                state.showSuccessMessage = false;
                state.showErrorMessage = false;
                state.showEmptyListMessage = true;
            }
            state.getCustomersReady = true;
        },
        // [doTvActivationCodeRecovery.fulfilled]: (state, action) => {
        //     state.isSuccess = action.payload;
        //     if (state.isSuccess == true) {
        //         state.showLoader = false;
        //         state.showCustomerList = false;
        //         state.showRecoveryButton = false;
        //         state.showSuccessMessage = true;
        //         state.showErrorMessage = false;
        //         state.showEmptyListMessage = false;
        //     } else {
        //         state.showLoader = false;
        //         state.showCustomerList = false;
        //         state.showRecoveryButton = false;
        //         state.showSuccessMessage = false;
        //         state.showErrorMessage = true;
        //         state.showEmptyListMessage = false;
        //     }
        // },
        [getTvCode.fulfilled]: (state, action) => {
            state.infoTv = action.payload.tvParameters;
        },
        [generateUserPasswordTv.fulfilled]: (state, action) => {
            state.activationCode = action.payload.result.activationCode;
        },
        [getPinParentalCodeAsync.fulfilled]: (state, action) => {
            const pin = action.payload?.tvParameters?.pin;
            state.pinParentalCode = pin;
            //state.parentalCodeStep = Step.RESET_CODE;
        },
        [tvActivationCodeRecoverySms.fulfilled]: (state, action) => {
            state.tvParameters = action.payload.tvParameters;
        },

        
    },
});

export const {
    setCurrentParrentalCodeAccount,
    setRequestData,
    prepareActivationCodeRecovery,
    closeFlow,
    startCall,
    setRedirectUrl,
    setParentalCodeStep,
    saveToHistory,
    setValidateUserAndCard,
    resetState,
    toggleDisplayPopUp,
    setSuccessMessage,
    setPasswordUpdate,
    setIsPasswordUpdate,
    reportDWH
} = tvActivationCodeRecoveryBlockSlice.actions;

export default tvActivationCodeRecoveryBlockSlice.reducer;
